var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clock-wrap"},[_c('span',{staticClass:"clock-date"},[_vm._v(_vm._s(_vm.date))]),_c('span',{staticClass:"clock-divider"},[_vm._v("|")]),_c('span',{staticClass:"clock-time"},[_vm._v(_vm._s(_vm.time))])])}
var staticRenderFns = []

export { render, staticRenderFns }